import { Outlet } from 'react-router-dom';
import { Box, Flex, FlexItem, Link } from '@gusto/workbench';
import AccountantFirm from '../../../../images/signupV2/AccountantFirm.svg';
import StarGinger from '../../../../images/signupV2/star-ginger.svg';

const BRAND_REFRESH_STAR_URL =
  'https://res.cloudinary.com/dja3z8nt6/image/upload/v1785878473/Star_wd74so.png';

const Layout = ({ brandRefreshSkin = false }: { brandRefreshSkin?: boolean }) => {
  return (
    <section className="partners-signup-layout">
      <Flex width="100wh" flexDirection="column" flexDirectionMd="row">
        <Flex
          heightMd="100vh"
          widthLg="50%"
          widthMd="54%"
          flexDirection="column"
          alignItems="center"
          justifyContent={brandRefreshSkin ? 'flex-start' : 'space-between'}
          className="get-started-box"
        >
          <Box textAlign="center" marginTop="20px" widthLg="60%">
            <h2>Welcome to Gusto for Accountants</h2>
            <p className="layout-subheading">
              Finish creating your account and add your clients. Up to 20% revenue share for your
              firm or discounts for your clients.{' '}
              <Link href="/legal/terms/partners" target="_blank" rel="noopener">
                Terms apply
              </Link>
              .
            </p>
          </Box>
          <Box className="add-client-promotion-card-wrapper">
            <Flex className="add-client-promotion-card" alignItems="center" justifyContent="center">
              <FlexItem flexBasis="15%">
                <img src={brandRefreshSkin ? BRAND_REFRESH_STAR_URL : StarGinger} alt="Star" />
              </FlexItem>
              <FlexItem flexBasis="85%">
                <div className="add-client-promotion-title">
                  Earn $400 for every client you introduce to Gusto Payroll.
                </div>
                <div className="grey-text">
                  Limited time offer.{' '}
                  <a href="https://gusto.com/legal/terms/promotional-terms">Terms</a> apply
                </div>
              </FlexItem>
            </Flex>
          </Box>
          {!brandRefreshSkin && (
            <img
              className="accounting_firm accounting_form_small_hide"
              alt="Accounting firm employees"
              src={AccountantFirm}
            />
          )}
        </Flex>
        <Flex
          widthLg="50%"
          widthMd="46%"
          alignItems="center"
          justifyContent="center"
          overflow="scroll"
          className="question-box"
        >
          <Outlet />
        </Flex>
      </Flex>
    </section>
  );
};

export default Layout;
